import { useEffect, useState, useCallback } from 'react'
import { Fab, styled } from '@mui/material'
import UpwardIcon from 'assets/icons/icon-navigation-arrow-upward.svg?react'

const TopButton = styled(Fab, {
  shouldForwardProp: (prop) => prop !== 'showTopButton'
})<{ showTopButton?: boolean }>(({ showTopButton, theme }) => ({
  position: 'fixed',
  bottom: theme.spacing(6),
  right: theme.spacing(3),
  transform: `translateY(${theme.spacing(20)})`,
  transition: theme.transitions.create(['transform', 'box-shadow'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.standard
  }),

  [theme.breakpoints.up('xl')]: {
    right: '50%',
    transform: `translate(${theme.spacing(102)}, ${theme.spacing(20)})`
  },

  '& svg path': {
    transition: theme.transitions.create('fill', {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.standard
    })
  },

  ...(showTopButton && {
    transform: `translateY(0)`,

    [theme.breakpoints.up('xl')]: {
      transform: `translate(${theme.spacing(102)}, 0)`
    }
  })
}))

interface BasicPageTopButtonProps {
  showScrollToTop?: boolean
}

function BasicPageTopButton({ showScrollToTop }: BasicPageTopButtonProps) {
  const [showTopButton, setShowTopButton] = useState<boolean>(false)

  useEffect(() => {
    const main: HTMLElement | null = document.querySelector('main')
    if (!main) {
      return
    }

    const scrollListener = () => {
      if (showScrollToTop) {
        setShowTopButton(main.scrollTop > 300)
      }
    }
    main.addEventListener('scroll', scrollListener)
    return () => {
      main?.removeEventListener('scroll', scrollListener)
    }
  }, [showScrollToTop, setShowTopButton])

  const scrollToTop = useCallback(() => {
    const main: HTMLElement | null = document.querySelector('main')
    if (!main) {
      return
    }

    main.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }, [])

  return (
    <TopButton showTopButton={showTopButton} onClick={scrollToTop} color="default">
      <UpwardIcon />
    </TopButton>
  )
}

export default BasicPageTopButton
